import styled from 'styled-components';
import breakpoint from '../breakpoints'

const trackingToLetterSpacing = (spacing) => `${spacing/1000}em`;

export const Wrapper = styled.section`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px solid #ccc;
  margin: auto;
  width: 90%;
  max-width: 1440px;
`

export const Heading = styled.div`
  text-align: center;
  margin: auto;
  width: 60%;
  padding: 40px 0;
  ${breakpoint('mobile', 'down')}{
    width: 100%;
    padding: 0;
  }
`

export const HeadingTitle = styled.h2`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  text-align: center;
  letter-spacing: ${trackingToLetterSpacing(0)};
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 10px;
`

export const HeadingDescription = styled.p`
  font-family: 'ToyotaType Book';
  letter-spacing: ${trackingToLetterSpacing(50)};
  text-align: center;
  font-size: 13px;
  line-height: 18px;
  ${breakpoint('mobile', 'down')}{
    padding: 0;
    padding-bottom: 10px;
  }
`

export const PartnershipsSection = styled.section`
  position: relative;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  ${breakpoint('mobile', 'down')}{
    margin: 0;
    width: 100%;
    flex-direction: column;
  }
`

export const PartnershipImage = styled.div`
  img {
    width: 100%;
  }
`

export const MainPartnershipImage = styled.div`
  img {
    width: 100%;
  }
`

export const PartnershipTitle = styled.h3`
  font-family: 'ToyotaType Bold';
  letter-spacing: ${trackingToLetterSpacing(0)};
  font-size: 20px;
  line-height: 26px;
  margin-bottom: 10px;
  
  ${breakpoint('mobile', 'down')}{
    line-height: 20px;
    margin: 0;
    text-align: left;
    text-transform: capitalize;
    padding-bottom: 10px;
  }
`

export const MoreOnTheWayTitle = styled.div`
  padding-top: 34px;
`

export const PartnershipSubtitle = styled.h3`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  letter-spacing: ${trackingToLetterSpacing(0)};
  font-size: 12px;
  line-height: 14px;
  margin-top: 20px;
  margin-bottom: 0;
`

export const PartnershipDescription = styled.p`
  font-family: 'ToyotaType Book';
  letter-spacing: ${trackingToLetterSpacing(50)};
  font-size: 13px;
  line-height: 18px;
  ${breakpoint('tablet', 'up')} {
    font-size: 13px;
    line-height: 18px;
  }
  ${breakpoint('tablet', 'down')}{
    text-align: left;
    padding-bottom: 10px;
    margin-bottom: 0;
  }
`

export const PartnershipLink = styled.a`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  text-decoration: underline;
  color: #CC0000;
  &:hover {
    color: #990000;
  }
  ${breakpoint('tablet', 'down')}{
    align-self: flex-start;
    padding: 0;
    font-size: 14px;
  }
`

export const MainPartnership = styled.div`
  padding-right: 25px;
  display: flex;
  flex: 0 0 calc(66.6666% - 25px);
  flex-direction: column;
  ${breakpoint('mobile', 'down')}{
    width: 100%;
    margin: 0 0 30px 0;
  }
`
export const Partnership = styled.div`
  margin-right: 12px;
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(33.3333% - 12px);
  ${breakpoint('mobile', 'down')}{
    width: 100%;
    margin: 0;
  }
`
export const PartnershipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`

export const PartnershipGallery = styled.div`
  display: flex;
`

export const ButtonRight = styled.div`
  position: absolute;
  left: 95%;
  margin-top: 36px;
  & > button {
    opacity: 0.7;
    color: red;
    background-color: white;
    border: 1px solid #ccc;
    & > img {
      transform: rotate(270deg);
    }
  }
`

export const ButtonLeft = styled.div`
  position: absolute;
  left: -1px;
  margin-top: 36px;
  & > button {
    height: 110px;
    width: 55px;
    opacity: 0.7;
    color: red;
    background-color: white;
    border: 1px solid #ccc;
    & > img {
      transform: rotate(90deg);
    }
  }
`